import { createGraphNode } from './node-registry.js';
import { CallCustomEventNode } from './nodes/call-custom-event-node.js';
function toCamelCase(name) {
    const trimmed = name.trim();
    if (!/\s/.test(trimmed)) {
        return trimmed.replace(/[^a-zA-Z0-9_]/g, '');
    }
    const parts = trimmed.split(/\s+/).filter(Boolean);
    const [first, ...rest] = parts;
    const toWord = (part, capitalize) => {
        const cleaned = part.replace(/[^a-zA-Z0-9]/g, '');
        if (!cleaned)
            return '';
        if (capitalize) {
            return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
        }
        return cleaned.toLowerCase();
    };
    return toWord(first, false) + rest.map((part) => toWord(part, true)).join('');
}
function wireOutConnections(currentNode, allNodes, connections) {
    const nextConnections = connections.filter((connection) => connection.source.nodeId === currentNode.id);
    for (const connection of nextConnections) {
        const nextNode = allNodes.find((node) => node.id === connection.target.nodeId);
        if (!nextNode)
            continue;
        const outKey = toCamelCase(connection.source.portKey);
        if (!currentNode.outConnections.has(outKey)) {
            currentNode.outConnections.set(outKey, []);
        }
        currentNode.outConnections.get(outKey).push({
            connectedNode: nextNode,
            inPortKey: toCamelCase(connection.target.portKey),
        });
    }
}
function wireInConnections(currentNode, allNodes, connections) {
    const previousConnections = connections.filter((connection) => connection.target.nodeId === currentNode.id);
    for (const connection of previousConnections) {
        const previousNode = allNodes.find((node) => node.id === connection.source.nodeId);
        if (!previousNode)
            continue;
        const inKey = toCamelCase(connection.target.portKey);
        if (!currentNode.inConnections.has(inKey)) {
            currentNode.inConnections.set(inKey, []);
        }
        currentNode.inConnections.get(inKey).push({
            connectedNode: previousNode,
            outPortKey: toCamelCase(connection.source.portKey),
        });
    }
}
/**
 * Builds a fresh set of GraphNode instances for a graph definition and wires
 * their connections. Used for the main graph and for each custom-function call.
 */
export function instantiateGraph(graph, nodeData = {}) {
    const nodes = graph.nodes.map((spec) => createGraphNode(spec, nodeData));
    for (const node of nodes) {
        if (node instanceof CallCustomEventNode) {
            node.bindGraphNodes(nodes);
        }
        wireOutConnections(node, nodes, graph.connections);
        wireInConnections(node, nodes, graph.connections);
    }
    return {
        nodes,
        getNodeById: (id) => nodes.find((node) => node.id === id),
    };
}
export { toCamelCase };
